import {
  Activity,
  BarChart3,
  Boxes,
  ClipboardList,
  CreditCard,
  FileCheck2,
  FileSearch,
  GitCompareArrows,
  History,
  Landmark,
  Layers,
  LayoutDashboard,
  Link2,
  Package,
  Plug,
  Receipt,
  Repeat,
  Scale,
  Server,
  Settings,
  Settings2,
  ShieldAlert,
  ShieldCheck,
  TrendingUp,
  Undo2,
  UserCog,
  Users,
  UsersRound,
  Wallet,
  Webhook,
  Zap,
} from 'lucide-react';
import type { LucideIcon } from 'lucide-react';
import { NAV_ITEMS } from './navigation';
import type { NavItem } from './navigation';

/**
 * Menu icons, in the lucide set Barah Plus uses. Kept out of navigation.ts so that module stays
 * data-only; the keys are the icon names it already carries.
 */
export const NAV_ICONS: Record<string, LucideIcon> = {
  dashboard: LayoutDashboard,
  'credit-card': CreditCard,
  'file-search': FileSearch,
  link: Link2,
  rollback: Undo2,
  exclamation: ShieldAlert,
  bank: Landmark,
  diff: GitCompareArrows,
  team: Users,
  sync: Repeat,
  'file-text': Receipt,
  appstore: Layers,
  shop: Package,
  api: Plug,
  'cloud-server': Webhook,
  thunderbolt: Zap,
  heart: Activity,
  'bar-chart': BarChart3,
  trending: TrendingUp,
  'file-check': FileCheck2,
  scale: Scale,
  user: UserCog,
  safety: ShieldCheck,
  history: History,
  setting: Settings,
};

export interface NavGroupMeta {
  group: NavItem['group'];
  labelKey: string;
  icon: LucideIcon;
}

/**
 * The collapsible sections of the sidebar, in order. Barah Plus opens its menu with a "Dashboards"
 * section, so the overview group is presented under that name.
 */
export const NAV_GROUPS: NavGroupMeta[] = [
  { group: 'overview', labelKey: 'navGroups.dashboards', icon: LayoutDashboard },
  { group: 'money', labelKey: 'navGroups.money', icon: Wallet },
  { group: 'reports', labelKey: 'navGroups.reports', icon: ClipboardList },
  { group: 'customers', labelKey: 'navGroups.customers', icon: UsersRound },
  { group: 'catalog', labelKey: 'navGroups.catalog', icon: Boxes },
  { group: 'platform', labelKey: 'navGroups.platform', icon: Server },
  { group: 'administration', labelKey: 'navGroups.administration', icon: Settings2 },
];

/**
 * The menu entry that owns a URL: the deepest path that matches it. '/payments/PAY-…' keeps Payments
 * lit, and '/' matches the dashboard only exactly — '/profile' is not "under" the dashboard.
 */
export function activeNavItem(pathname: string): NavItem | undefined {
  return NAV_ITEMS.filter((item) =>
    item.path === '/' ? pathname === '/' : pathname === item.path || pathname.startsWith(`${item.path}/`),
  ).sort((a, b) => b.path.length - a.path.length)[0];
}
